import React, { memo, useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import { useDeepEqualSelector, useDeepCompareMemoize } from 'Shared/utils/hooks';
import NewMeetingsModal from 'Shared/components/modals/SyncCalendarFlowModals/NewMeetingsModal/NewMeetingsModal';
import { updateProfile } from 'Shared/actions/user';

function NewMeetingsModalHandler() {
  const history = useHistory();
  const dispatch = useDispatch();
  const newMeetingsModalData = useDeepEqualSelector(state => state.user.newMeetingsModalData);
  const newMeetingsModalCompletedAt = useSelector(state => state.user.newMeetingsModalCompletedAt);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (
      (newMeetingsModalData?.one_on_one_suggestions?.length > 0 ||
        newMeetingsModalData?.group_suggestions?.length > 0) &&
      (!newMeetingsModalCompletedAt || moment(newMeetingsModalCompletedAt).unix() < moment().subtract(1, 'week').unix())
    ) {
      setIsOpen(true);
      (window as any).analytics.track('Opened Modal', { modal: 'New Meetings' });
    }
  }, [useDeepCompareMemoize(newMeetingsModalData), newMeetingsModalCompletedAt]);

  const handleClose = useCallback(
    ({ finishButtonClicked, autoComplete, redirectPath } = {}) => {
      (window as any).analytics.track('Clicked in New Meetings Modal', {
        autoComplete: Boolean(autoComplete),
        button: finishButtonClicked ? 'finish' : 'dismiss',
      });
      setIsOpen(false);
      if (redirectPath) history.push(redirectPath);
      dispatch(updateProfile({ new_meetings_modal_completed_at: moment().format() }, { supressSuccessMessage: true }));
    },
    [dispatch, history]
  );

  if (!isOpen) return null;

  return <NewMeetingsModal onToggle={handleClose} newMeetingsModalData={newMeetingsModalData} />;
}

export default memo(NewMeetingsModalHandler);
